import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export interface ScheduleItem {
    startdate: string;
    starttime: string;
    enddate: string;
    endtime: string;
}

@Component({
    selector: 'app-ta-type-multitable',
    templateUrl: './ta-type-multitable.component.html',
    styleUrls: ['./ta-type-multitable.component.scss'],
})
export class TaTypeMultitableComponent implements OnInit, OnChanges {
    @Input() data: string | ScheduleItem[] | any = '';

    parsedDisplayData: ScheduleItem[] = [];
    is24x7: boolean = false;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit() {
        console.log('RECEIVED DATA', this.data);
        this.parseData(this.data);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            this.parseData(this.data);
        }
    }

    private parseData(inputData: any) {
        this.is24x7 = false;
        this.parsedDisplayData = [];

        if (!inputData) return;

        // Case 1: inputData is a string
        if (typeof inputData === 'string') {
            const trimmed = inputData.trim();

            if (trimmed === '24x7') {
                this.is24x7 = true;
                console.log('INSIDE TRIMMED TRUE', this.is24x7);
                return;
            }

            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) this.parsedDisplayData = parsed;
            } catch (e) {
                console.error('Invalid JSON (string case):', e);
            }

            return;
        }

        // Case 2: inputData is an array
        if (Array.isArray(inputData)) {
            if (inputData.length === 1 && inputData[0] === '24x7') {
                this.is24x7 = true;
                console.log('INSIDE ARRAY 24x7 TRUE', this.is24x7);
                return;
            }

            this.parsedDisplayData = inputData;
            return;
        }

        // Case 3: inputData is an object
        if (typeof inputData === 'object') {
            this.parsedDisplayData = [inputData];
            return;
        }

        console.warn('Unexpected inputData format:', inputData);
    }
}
